import React from 'react';
import { Modal } from 'react-bootstrap';
import { hideToaster } from '../redux/actions/app';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import { useRef } from 'react';

function ToastMessage({ hideToaster, message = '' }) {
  const [show, setShow] = useState(false);
  const timerRef = useRef(null);

  const handleClose = useCallback(() => {
    hideToaster();
  }, [hideToaster]);

  useEffect(() => {
    const visible = message !== '';
    setShow(visible);

    // autohide
    if (!visible) {
      return;
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      handleClose();
    }, 1200);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [message, handleClose]);

  return (
    <Modal id='message' show={show} onHide={handleClose}>
      <Modal.Body
        style={{
          fontSize: '1.15rem',
          textAlign: 'center',
          color: 'green',
          padding: '20px 18px',
        }}
      >
        {message}
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  message: state.app.toastMessage,
});

const mapDispatchToProps = {
  hideToaster,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToastMessage);
